import axios from 'axios';
import Api from '@/services/Api'
import authHeader from '@/services/AuthHeader'

export default {
  MODEL: 'model',
  WALL: 'wall',
  async loadTags() {
    return await Api().get(process.env.VUE_APP_QUERY_URL_TAGS)
      .then(res => {
        var tagObjects = res.data;
        var tags = [];
        tagObjects.forEach(tagObj => {
          tags.push(tagObj);
		});
		tags.sort((tag1, tag2) => tag1.name.localeCompare(tag2.name));
        return tags;
      })
      .catch(err => {
        console.log(err);
      });
  },
  async createNewTag(tag) {
  	await Api().post(process.env.VUE_APP_QUERY_URL_TAGS, tag)
	    .then(function (response) {
		    console.log('>>> new tag created on server with response: '+response);
	    })
	    .catch(function (error) {
		    console.log(error);
	    })
  },
  async updateTag(tag) {
    var url = process.env.VUE_APP_QUERY_URL_TAGS + '/' + tag.id;
    await Api().put(url, tag)
      .then(function (response) {
        console.log('>>> tag updated on server with response: ' + response);
      })
      .catch(function (error) {
        console.log(error);
      })
  },
  async deleteTag(tag) {
    var url = process.env.VUE_APP_QUERY_URL_TAGS + '/' + tag.id;
    await Api().delete(url)
      .then(function (response) {
        console.log('>>> tag deleted on server with response: ' + response);
      })
      .catch(function (error) {
        console.log(error);
      })
  },
  async loadSlides(type) {
    var url = (type === this.MODEL) ? process.env.VUE_APP_QUERY_URL_MODEL_SLIDES : process.env.VUE_APP_QUERY_URL_WALL_SLIDES;
    return await Api().get(url)
      .then(res => {
        var slides = res.data;
        var slideList = [];
        slides.forEach(slide => {
          slideList.push(slide);
        });
        return slideList;
      })
      .catch(err => {
        console.log(err);
      });
  },
  async deleteSlide(slide) {
    var url = (slide.type === this.MODEL) ? (process.env.VUE_APP_QUERY_URL_MODEL_SLIDES + '/' + slide.id) : (process.env.VUE_APP_QUERY_URL_WALL_SLIDES + '/' + slide.id);
    await Api().delete(url)
      .then(function (response) {
        //console.log('>>> delete wall slide with id='+slide.id);
        console.log('>>> slide deleted on server with response: ' + response);
      })
      .catch(function (error) {
        console.log(error);
      })
  },
  async update(slide) {
    var url = (slide.type === this.MODEL) ? (process.env.VUE_APP_QUERY_URL_MODEL_SLIDES + '/' + slide.id) : (process.env.VUE_APP_QUERY_URL_WALL_SLIDES + '/' + slide.id);
    await Api().put(url, slide)
      .then(function (response) {
        console.log('>>> slide updated on server with response: ' + response);
      })
      .catch(function (error) {
        console.log(error);
      })
  },
  async getSlide(type, id) {
    console.log("get slide " + type + " id " + id);
    let url = (type === this.MODEL) ? process.env.VUE_APP_QUERY_URL_MODEL_SLIDES : process.env.VUE_APP_QUERY_URL_WALL_SLIDES;
    url +=  '/' + id;
    return axios.request({
      url: url,
      method: 'get',
      baseURL: process.env.VUE_APP_BASE_URL,
      headers: authHeader()
    })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  async createNewSlide(formData, type) {
	  var url = (type === this.MODEL) ? process.env.VUE_APP_QUERY_URL_MODEL_SLIDES : process.env.VUE_APP_QUERY_URL_WALL_SLIDES;
  	await Api().post(url, formData)
	    .then(function (response) {
		    console.log('>>> new slide created on server with response: '+response);
	    })
	    .catch(function (error) {
		    console.log(error);
	    })
  }
}